const adminMenuItems = [
    {
        name: "จัดการผลหวย",
        icon: "ApertureIcon",
        submenu: [
            {
                url: '/',
                name: 'ผลหวยรายวัน',
                slug: 'admin-lotto-results'
            },
            {
                url: '/add-results',
                name: 'ออกผลหวย',
                slug: 'admin-add-results'
            }
        ]
    }
]

const memberMenuItems = [
    {
        url: "/",
        name: "Home",
        slug: "home",
        icon: "HomeIcon"
    }
]

export { adminMenuItems, memberMenuItems }
